import React, { useEffect } from 'react';
import { Stack, Select, MenuItem, Pagination, Typography } from '@mui/material';

interface PaginationProps {
  rows: any[],
  rowsPerPage: any,
  page: any,
  setRowsPerPage: any,
  setPage: any
  arrayPages: number[]
}

const Paginations: React.FC<PaginationProps> = ({
  rows,
  rowsPerPage,
  page,
  setRowsPerPage,
  setPage,
  arrayPages
}) => {

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage - 1);
  };

  useEffect(() => {
  }, [rows]);

  return rows.length > 0 ? (
    <Stack
      spacing={1}
      direction="row"
      alignItems="center"
      justifyContent="flex-end">
      <Pagination
        count={Math.ceil(rows.length / rowsPerPage)}
        page={page + 1}
        onChange={handleChangePage}
        color="primary"
        siblingCount={1}
        boundaryCount={0}
        sx={{
          '& .MuiPaginationItem-root': {
            color: 'var(--text-color)',
            fontSize: 12,
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: 'rgba(25, 118, 210, 0.8)', 
            color: 'white',
          }
        }}
      />
      <Typography
        variant="body2"
        sx={{ color: 'var(--text-color)' }}>
        {`${page * rowsPerPage + 1}–${Math.min(
          (page + 1) * rowsPerPage,
          rows.length
        )} of ${rows.length}`}
      </Typography>
      <Select
        value={rowsPerPage}
        onChange={handleChangeRowsPerPage}
        size="small"
        sx={{
          color: 'var(--text-color)',
          padding: '0 20px 0 10px',
          fontSize: 12,
          '.MuiSvgIcon-root': {
            color: 'white'
          },
          backgroundColor: 'var(--bg-pagination)',
        }}>
        {arrayPages.map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  ) : null
};

export default Paginations;
